import DealsCarousel from './DealsCarousel';
import ProductsCarousel from './ProductsCarousel';
import OrderCarousel from './OrderCarousel';
import MostPopularProducts from './most-popular-products';

export default {
  DealsCarousel,
  OrderCarousel,
  ProductsCarousel,
  MostPopularProducts,
};
